export const loanQuestions: Record<string, any> = {
  borrower: {
    labelKey: 'applicationForm.ADD_STUDENT_LOAN.whose.label',
    placeholder: 'placeholders.select',
  },
  monthlyPayment: {
    labelKey: 'applicationForm.ADD_STUDENT_LOAN.monthlyPayment.label',
  },
};
